/* eslint-disable jsx-a11y/label-has-associated-control */
import TableWrapper from 'components/common/table-wrapper/TableWrapper'
import { alertTypes, initialMetaForTable } from 'constants/Common'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
// import { useNavigate } from 'react-router-dom'
import { getAccessToken, getOrgIdFromStorage } from 'utils/common'
import UploadIcon from 'assets/images/shell/icon-upload.svg'
import DownloadIcon from 'assets/images/shell/icon-download.svg'
import AddIcon from 'assets/images/shell/icon-add.svg'
import ViewListIcon from 'assets/images/shell/icon-view-list.svg'
import ViewGridIcon from 'assets/images/shell/icon-view-grid.svg'
import MoreIcon from 'assets/images/shell/icon-more.svg'
import SortIcon from 'assets/images/shell/icon-sort.svg'
import CustomModal from 'components/common/modal/CustomModal'
import { Formik } from 'formik'
// import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { get, post } from 'services/network'
import Modal from 'react-bootstrap/Modal'
import {
  userInitialValues,
  userValidationSchema,
} from 'constants/Users'
import {
  UploadFile,
  createUser,
  deleteUser,
  exportUsers,
  getUsers,
  userStatusUpdate,
  userUpdate,
} from 'containers/users/Api'
import { getTeams } from 'containers/Teams/Api'
import { Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
import { useDropzone } from 'react-dropzone'
import UserDelete from './UserDelete'
import UserCreateModal from './UserCreateModal'

let timeout
const DEBOUNCE_DELAY = 700

function normalizeUserType(value) {
  return String(value || 'user').trim().toLowerCase()
}

function userMatchesTypeFilter(user, typeFilter) {
  const normalizedFilter = normalizeUserType(typeFilter)
  if (!normalizedFilter) return true

  const userType = normalizeUserType(user?.type)
  if (normalizedFilter === 'speaker') return userType === 'speaker'
  if (normalizedFilter === 'user') return userType !== 'speaker'
  if (normalizedFilter === 'admin') return userType === 'admin'
  return true
}

function UsersListing() {
  //   const navigate = useNavigate()
  const [usersList, setUsersList] = useState([])
  const [teamsList, setTeamsList] = useState([])
  const [teamsLoading, setTeamsLoading] = useState(false)
  const [organizationsList, setOrganizationsList] = useState([])
  const [loading, setLoading] = useState(true)
  const [meta, setMeta] = useState({
    ...initialMetaForTable,
    perPage: 10,
    type: '',
  })
  const [isUserModalVisible, setUserModalVisible] = React.useState(false)
  const [refresh, setRefresh] = useState(false)
  const [postContent, setPostContent] = useState(false)
  const [selectedUser, setSelectedUser] = useState()
  const [isUserDeleteModalVisible, setDeleteUserModalVisible] = useState(false)
  const [isPostContentModalVisible, setIsPostContentModalVisible] =
    useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [openActionId, setOpenActionId] = useState(null)
  const [selectedIds, setSelectedIds] = useState([])
  const [tabCounts, setTabCounts] = useState({
    all: 0,
    admin: 0,
    approved: 0,
    pending: 0,
    rejected: 0,
  })
  const inputRef = useRef(null)
  const currentOrganizationId = getOrgIdFromStorage() || ''
  const getNormalizedOrganizationIds = (user) => {
    if (!user) return [currentOrganizationId].filter(Boolean)

    if (Array.isArray(user.organizationIds)) {
      return user.organizationIds.map((item) => String(item)).filter(Boolean)
    }

    if (Array.isArray(user.organizationId)) {
      return user.organizationId.map((item) => String(item)).filter(Boolean)
    }

    if (user.organizationId) {
      return [String(user.organizationId)]
    }

    return [currentOrganizationId].filter(Boolean)
  }

  const handleRefresh = () => {
    setRefresh((pre) => !pre)
  }
  const handleSetPerPage = (obj) => {
    setMeta((pre) => ({ ...pre, perPage: obj.value, page: 1 }))
    handleRefresh()
  }
  const debounceFn = (callback, delay) => {
    clearTimeout(timeout)
    timeout = setTimeout(callback, delay)
  }
  const handleSetSearchQuery = (value) => {
    setMeta((pre) => ({ ...pre, search: value }))
    debounceFn(handleRefresh, DEBOUNCE_DELAY)
  }
  const handlePageChange = (value) => {
    setMeta((pre) => ({ ...pre, page: value }))
    handleRefresh()
  }
  const handleCloseModal = () => {
    setUserModalVisible(false)
    setSelectedUser()
  }

  const handleExportUsers = async () => {
    setIsExporting(true)
    try {
      const response = await exportUsers(meta.search, meta.status)
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      const date = new Date().toISOString().split('T')[0]
      link.setAttribute('download', `Users_Export_${date}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.error(error)
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message='Error exporting users'
        />
      )
    } finally {
      setIsExporting(false)
    }
  }
  const fetchUsers = async () => {
    const isAdminTab = meta.type === 'admin'
    const result = await getUsers(
      meta.page,
      meta.perPage,
      meta.search,
      isAdminTab ? '' : meta.status,
      isAdminTab ? 'admin' : ''
    )
    if (result?.LastPage && result?.Total) {
      const resultMeta = result
      setMeta((pre) => ({
        ...pre,
        totalCount: resultMeta.Total,
        totalPages: resultMeta.LastPage,
      }))
    }
    if (result?.data) {
      const { data } = result
      const start = (meta.page - 1) * meta.perPage
      const serverIgnoredAdminFilter =
        isAdminTab &&
        data.some((user) => normalizeUserType(user?.type) !== 'admin')
      if (serverIgnoredAdminFilter) {
        const everyone = await getUsers(1, result.Total || data.length, meta.search, '')
        const admins = Array.isArray(everyone?.data)
          ? everyone.data.filter(
              (user) => normalizeUserType(user?.type) === 'admin'
            )
          : []
        setUsersList(admins.slice(start, start + meta.perPage))
        setMeta((pre) => ({
          ...pre,
          totalCount: admins.length,
          totalPages: Math.max(1, Math.ceil(admins.length / meta.perPage)),
        }))
      } else {
        const pageRows =
          !isAdminTab && data.length > meta.perPage
            ? data.slice(start, start + meta.perPage)
            : data
        setUsersList(pageRows)
      }
    }
    const [all, approved, pending, rejected, adminPage] = await Promise.all([
      getUsers(1, 1, meta.search, ''),
      getUsers(1, 1, meta.search, 'approved'),
      getUsers(1, 1, meta.search, 'pending'),
      getUsers(1, 1, meta.search, 'rejected'),
      getUsers(1, 1, meta.search, '', 'admin'),
    ])
    let adminCount = adminPage?.Total || 0
    const adminSample = adminPage?.data?.[0]
    const adminFilterIgnored =
      adminCount > 0 &&
      adminCount === (all?.Total || 0) &&
      adminSample &&
      normalizeUserType(adminSample.type) !== 'admin'
    if (adminFilterIgnored) {
      const everyone = await getUsers(1, adminCount, meta.search, '')
      adminCount = Array.isArray(everyone?.data)
        ? everyone.data.filter(
            (user) => normalizeUserType(user?.type) === 'admin'
          ).length
        : 0
    }
    setTabCounts({
      all: all?.Total || 0,
      approved: approved?.Total || 0,
      pending: pending?.Total || 0,
      rejected: rejected?.Total || 0,
      admin: adminCount,
    })
    setLoading(false)
    // console.log('user meta', meta)
  }

  const fetchTeams = async (perPage = meta.perPage) => {
    setTeamsLoading(true)
    const result = await getTeams(meta.page, perPage, meta.search)
    if (result?.teams) {
      setTeamsList(result.teams)
    } else {
      setTeamsList([])
    }
    setTeamsLoading(false)
  }
  const fetchOrganizations = async () => {
    try {
      const response = await get('organization', false, null, null, {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      })
      const payload = Array.isArray(response)
        ? response
        : response?.organizations || response?.data || []
      setOrganizationsList(payload)
    } catch (error) {
      setOrganizationsList([])
    }
  }
  const handleOpenModal = () => {
    setUserModalVisible(true)
  }
  const handleUpdateUserStatus = async (id, status) => {
    const result = await userStatusUpdate({ userId: id, status })
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'User Updated Successfully!'}
        />
      )
      handleRefresh()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }
  const handleCreateUser = async (values) => {
    const { organizationIds, teamId, ...restValues } = values
    const selectedOrganizationIds = values.organizationIds || []
    const isSpeaker = values.type === 'speaker'
    const fullName = `${values.firstName || ''} ${values.lastName || ''}`.trim()
    const result = await createUser({
      ...restValues,
      ...(teamId ? { teamId } : {}),
      organizationId: selectedOrganizationIds.length
        ? selectedOrganizationIds
        : [currentOrganizationId].filter(Boolean),
      phone: String(values.phone || ''),
      type: values.type || 'user',
      name: isSpeaker ? fullName || values.name : values.name,
      image: values.image || '',
      description: values.description || '',
      designation: values.designation || '',
      ...(isSpeaker
        ? {
            jobTitle: values.designation || '',
          }
        : {}),
    })
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'User Created Successfully!'}
        />
      )
      handleRefresh()
      handleCloseModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const handleUpdateUser = async (values) => {
    const { organizationIds, teamId, password, ...restValues } = values
    const selectedOrganizationIds = values.organizationIds || []
    const isSpeaker = values.type === 'speaker'
    const fullName = `${values.firstName || ''} ${values.lastName || ''}`.trim()
    const result = await userUpdate({
      ...restValues,
      ...(password?.trim() ? { password: password.trim() } : {}),
      ...(teamId ? { teamId } : {}),
      organizationId: selectedOrganizationIds,
      type: values.type,
      name: isSpeaker ? fullName || values.name : values.name,
      image: values.image || '',
      description: values.description || '',
      designation: values.designation || '',
      ...(isSpeaker
        ? {
            jobTitle: values.designation || '',
          }
        : {}),
    })
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'User Deleted Successfully!'}
        />
      )
      handleCloseModal()
      handleRefresh()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }
  const handleCloseUserDeleteModal = () => {
    setDeleteUserModalVisible(false)
    setSelectedUser()
  }
  const handleOpenDeleteUserModal = () => {
    setDeleteUserModalVisible(true)
  }
  const handleDeleteUser = async () => {
    // eslint-disable-next-line no-underscore-dangle
    const result = await deleteUser(selectedUser._id)
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'User Deleted Successfully!'}
        />
      )
      handleRefresh()
      handleCloseUserDeleteModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }
  const handleImportUsers = () => {
    inputRef.current.click()
  }
  const handleFileUpload = async (file) => {
    const formData = new FormData()
    formData.append('file', file)
    const result = await UploadFile(formData)
    if (result?.status === 200 || (result?.message && result?.stats)) {
      handleRefresh()
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={
            result?.message ||
            result?.statusText ||
            'Users Created Successfully!'
          }
        />
      )
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error || 'Error uploading file'}
        />
      )
    }
  }
  const onDrop = useCallback((acceptedFiles) => {
    // Do something with the accepted files (e.g., send them to the server)
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0]
      console.log('file is ', file)
      handleFileUpload(file)
    }
  }, [])
  const { getInputProps } = useDropzone({ onDrop })

  const postContentModal = (value) => {
    setIsPostContentModalVisible(value)
  }

  const submitPostContent = async () => {
    const data = {
      postContent,
    }
    try {
      const response = await post(
        `${process.env.REACT_APP_API_URL}user/postContent`,
        data,
        true
      )

      console.log(response)
      setIsPostContentModalVisible(false)
      toast(
        <CustomToast variant={alertTypes.SUCCESS} message={response.message} />
      )
      return response
    } catch (error) {
      console.error(error)
      toast(
        <CustomToast variant={alertTypes.DANGER} message='error creating!' />
      )
      return false
    }
  }

  const filteredUsersList = useMemo(
    () => usersList.filter((user) => userMatchesTypeFilter(user, meta.type)),
    [usersList, meta.type]
  )

  const totalListCount = meta.totalCount || 0
  const activeTab = meta.type === 'admin' ? 'admin' : meta.status || 'all'
  const statusLabel = (status) => {
    if (status === 'approved') return 'Approved'
    if (status === 'rejected') return 'Rejected'
    return 'Pending'
  }
  const selectTab = (tab) => {
    setOpenActionId(null)
    if (tab === 'all') {
      setMeta((pre) => ({ ...pre, status: '', type: '', page: 1 }))
    } else if (tab === 'admin') {
      setMeta((pre) => ({ ...pre, status: '', type: 'admin', page: 1 }))
    } else {
      setMeta((pre) => ({ ...pre, status: tab, type: '', page: 1 }))
    }
    handleRefresh()
  }
  const visibleIds = filteredUsersList.map((item) => item._id || item.id)
  const allVisibleSelected =
    visibleIds.length > 0 && visibleIds.every((id) => selectedIds.includes(id))
  const toggleAllVisible = () => {
    setSelectedIds((current) =>
      allVisibleSelected
        ? current.filter((id) => !visibleIds.includes(id))
        : [...new Set([...current, ...visibleIds])]
    )
  }
  const toggleSelected = (id) => {
    setSelectedIds((current) =>
      current.includes(id)
        ? current.filter((item) => item !== id)
        : [...current, id]
    )
  }

  useEffect(() => {
    fetchUsers()
    fetchTeams()
    fetchOrganizations()
    // Reload when the page, page size, tab, or a refresh changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, meta.page, meta.perPage, meta.status, meta.type])

  useEffect(() => {
    if (!isUserModalVisible) {
      return
    }
    fetchTeams(500)
    fetchOrganizations()
  }, [isUserModalVisible])
  return (
    <div className='user-main'>
      <input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...getInputProps()}
        ref={inputRef}
        style={{ display: 'none' }} // Hide the input element
      />
      <div className='container-fluid'>
        <TableWrapper
          eventFilterHeader
          footerVariant='listing'
          totalLabel='Total Users'
          searchPlaceholder='Search...'
          setPerPage={handleSetPerPage}
          setSearchQuery={handleSetSearchQuery}
          searchValue={meta.search}
          totalListCount={totalListCount}
          pageSize={meta.perPage}
          currentPage={meta.page}
          onPageChange={handlePageChange}
          actionButtons={[
            {
              label: 'Import users',
              ariaLabel: 'Import users',
              icon: <img src={UploadIcon} width={20} height={20} alt='' />,
              handleClick: handleImportUsers,
              classes: 'user-icon-btn',
            },
            {
              label: isExporting ? 'Exporting' : 'Export users',
              ariaLabel: 'Export users',
              icon: <img src={DownloadIcon} width={20} height={20} alt='' />,
              handleClick: isExporting ? () => {} : handleExportUsers,
              classes: 'user-icon-btn',
            },
            {
              label: 'Add user',
              ariaLabel: 'Add user',
              icon: <img src={AddIcon} width={20} height={20} alt='' />,
              handleClick: handleOpenModal,
              classes: 'user-icon-btn',
            },
          ]}
        >
          <div className='user-tabs'>
            {[
              ['all', 'All'],
              ['admin', 'Admin'],
              ['approved', 'Approved'],
              ['pending', 'Pending'],
              ['rejected', 'Rejected'],
            ].map(([value, label]) => (
              <button
                key={value}
                type='button'
                className={`user-tab${activeTab === value ? ' user-tab--active' : ''}`}
                onClick={() => selectTab(value)}
              >
                <span>{label}</span>
                <span className='user-tab__count'>
                  {String(tabCounts[value] || 0).padStart(2, '0')}
                </span>
              </button>
            ))}
            <div className='user-view'>
              <button type='button' className='user-view__btn user-view__btn--active' aria-label='Listing'>
                <img src={ViewListIcon} width={20} height={20} alt='' />
              </button>
              <span className='user-view__rule' />
              <button type='button' className='user-view__btn' aria-label='Grid'>
                <img src={ViewGridIcon} width={20} height={20} alt='' />
              </button>
            </div>
          </div>
          {loading ? (
            <p style={{ textAlign: 'center' }}>Loading</p>
          ) : (
            <table className='table user-table'>
              <thead>
                <tr>
                  <th scope='col'>
                    <input
                      type='checkbox'
                      aria-label='Select all users'
                      checked={allVisibleSelected}
                      onChange={toggleAllVisible}
                    />
                  </th>
                  <th scope='col'>User Name</th>
                  <th scope='col'>Company</th>
                  <th scope='col'>Team</th>
                  <th scope='col'>Email</th>
                  <th scope='col'>Phone Number</th>
                  <th scope='col'>
                    <span className='user-table__status-heading'>
                      Status
                      <img src={SortIcon} width={20} height={20} alt='' />
                    </span>
                  </th>
                  <th scope='col' className='action-column'>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredUsersList?.length > 0 ? (
                  filteredUsersList.map((item) => (
                    <tr key={item._id || item.id}>
                    <td>
                      <input
                        type='checkbox'
                        aria-label={`Select ${item.name || 'user'}`}
                        checked={selectedIds.includes(item._id || item.id)}
                        onChange={() => toggleSelected(item._id || item.id)}
                      />
                    </td>
                    <td>
                      <p className='user-table__name' title={item.name}>
                        {item.name}
                      </p>
                    </td>
                    <td>
                      <div className='table-text-otr'>
                        <p className='table-text-black' title={item.company}>
                          {item.company}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className='table-text-otr'>
                        <p
                          className='table-text-black'
                          title={item.gender?.toUpperCase()}
                        >
                          {item.teamInfo?.name}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className='table-text-otr'>
                        <p className='table-text-black' title={item.email}>
                          {item.email}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className='table-text-otr'>
                        <p className='table-text-black' title={item.phone}>
                          {item.phone}
                        </p>
                      </div>
                    </td>

                    <td>
                      <span
                        className={`user-status user-status--${item.status || 'pending'}`}
                      >
                        <span className='user-status__dot' />
                        {statusLabel(item.status)}
                      </span>
                    </td>

                    <td className='action-column'>
                      <div className='user-actions'>
                        <button
                          type='button'
                          className='user-actions__button'
                          aria-label='User actions'
                          onClick={() =>
                            setOpenActionId((current) =>
                              current === (item._id || item.id)
                                ? null
                                : item._id || item.id
                            )
                          }
                        >
                          <img src={MoreIcon} width={20} height={20} alt='' />
                        </button>
                        {openActionId === (item._id || item.id) && (
                          <div className='user-actions__menu'>
                            <button
                              type='button'
                              onClick={() => {
                                setSelectedUser(item)
                                setOpenActionId(null)
                                handleOpenModal()
                              }}
                            >
                              Edit
                            </button>
                            <button
                              type='button'
                              onClick={() => {
                                setSelectedUser(item)
                                setOpenActionId(null)
                                handleOpenDeleteUserModal()
                              }}
                            >
                              Delete
                            </button>
                            <button
                              type='button'
                              onClick={() => {
                                setOpenActionId(null)
                                handleUpdateUserStatus(
                                  item._id,
                                  item.status === 'approved'
                                    ? 'pending'
                                    : 'approved'
                                )
                              }}
                            >
                              {item.status === 'approved'
                                ? 'Mark pending'
                                : 'Approve'}
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan='8'>
                      <p className='mb-0 py-3 text-center'>No users found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </TableWrapper>
      </div>
      {isUserDeleteModalVisible && (
        <UserDelete
          handleDeleteUser={handleDeleteUser}
          handleCloseModal={handleCloseUserDeleteModal}
        />
      )}

      {/* {isPostContentModalVisible && ( */}
      <Modal
        size='sm'
        show={isPostContentModalVisible}
        onHide={() => setIsPostContentModalVisible(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Post Content</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {' '}
          <Form.Control
            type='text'
            placeholder='Post Content'
            onInput={(e) => setPostContent(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            className='border-0'
            // variant='secondary'
            style={{ backgroundColor: '#9b945f' }}
            onClick={() => submitPostContent()}
          >
            Submit
          </Button>
          {/* <Button variant='primary' onClick={handleClose}>
              Save Changes
            </Button> */}
        </Modal.Footer>
      </Modal>
      {/* )} */}

      {isUserModalVisible && (
        <CustomModal
          size='md'
          show
          onHide={handleCloseModal}
          heading={`${selectedUser ? 'Edit' : 'Create'} User`}
        >
          <Formik
            initialValues={
              selectedUser
                ? {
                    ...selectedUser,
                    organizationIds: getNormalizedOrganizationIds(selectedUser),
                    image: selectedUser.image || '',
                    description: selectedUser.description || '',
                    designation:
                      selectedUser.designation || selectedUser.jobTitle || '',
                    password: '',
                  }
                : {
                    ...userInitialValues,
                    organizationIds: [currentOrganizationId].filter(Boolean),
                  }
            }
            validationSchema={userValidationSchema}
            onSubmit={(values) => {
              if (selectedUser) {
                handleUpdateUser(values)
              } else handleCreateUser(values)
            }}
          >
            {({ handleChange, values, handleSubmit, setFieldValue }) => (
              <UserCreateModal
                handleCloseModal={handleCloseModal}
                selectedUser={selectedUser}
                handleChange={handleChange}
                values={values}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                teamsList={teamsList}
                teamsLoading={teamsLoading}
                organizationsList={organizationsList}
                currentOrganizationId={currentOrganizationId}
              />
            )}
          </Formik>
        </CustomModal>
      )}
    </div>
  )
}

export default UsersListing
